import * as types from "../actions/types";



const initialState = {
  list: [],
  loading: false
};


export default function log_setting(state = initialState, action) {
  switch (action.type) {

    case types.SET_LOG_SETTING:
      return {
        ...state,
        logSettingList: action.payload,
      };
    case types.SET_LOG_SETTING_TABLES:
      return {
        ...state,
        logSettingTables: action.payload,
      };
    case types.SET_LOG_SETTING_TABLES_COLUMNS:
      return {
        ...state,
        logSettingTablesColumns: action.payload,
      };

    case types.SET_LOG_SETTING_TABLES_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
}